import { Link } from 'react-router-dom';

export const DisclaimerPage = () => {
  return (
    <main className="pt-20" data-testid="disclaimer-page">
      {/* Page Header */}
      <section className="page-header py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Disclaimer
            </h1>
            <p className="text-stone-600">Last updated: December 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 section-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-stone prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Website Disclaimer</h2>
            <p className="text-stone-600 mb-6">
              The information provided on this website is for general informational purposes only. While we strive to keep the information up to date and accurate, Buy Fusion makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Professional Advice</h2>
            <p className="text-stone-600 mb-6">
              The content on this website does not constitute professional flooring advice. Every flooring project is unique, and specific recommendations should be obtained through a personal consultation with our team. Decisions regarding flooring materials, installation methods, and maintenance should be made after a thorough assessment of your specific situation.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Project Estimates</h2>
            <p className="text-stone-600 mb-6">
              Any pricing or timeline estimates mentioned on this website are general guidelines only. Actual project costs and completion times may vary based on factors including but not limited to: project scope, material selection, site conditions, accessibility, and current market conditions. Official estimates are provided only after an in-person or virtual consultation.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Images and Representations</h2>
            <p className="text-stone-600 mb-6">
              Images displayed on this website are for illustrative purposes. Actual flooring materials, colors, and finishes may vary from what is shown due to photography, screen displays, and natural variations in materials. We recommend viewing actual samples before making final selections.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">External Links</h2>
            <p className="text-stone-600 mb-6">
              This website may contain links to external sites that are not operated by Buy Fusion. We have no control over the content and nature of these sites and are not responsible for their content, privacy policies, or practices.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Limitation of Liability</h2>
            <p className="text-stone-600 mb-6">
              In no event will Buy Fusion be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Service Area</h2>
            <p className="text-stone-600 mb-6">
              Our services are primarily available in Los Angeles County and surrounding areas. Service availability in specific locations should be confirmed directly with our team.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">Contact Us</h2>
            <p className="text-stone-600 mb-4">
              If you have any questions about this disclaimer, please contact us:
            </p>
            <div className="bg-stone-50 rounded-xl p-6 mb-6">
              <p className="text-stone-700">
                <strong>Buy Fusion - Premium Flooring Co.</strong><br />
                88 Sunset Boulevard<br />
                Los Angeles, CA 800134<br />
                Email: <a href="mailto:support@buyfusion.store" className="text-amber-600 hover:text-amber-700">support@buyfusion.store</a><br />
                Phone: <a href="tel:+18888791244" className="text-amber-600 hover:text-amber-700">+1-888-879-1244</a>
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <Link to="/" className="text-amber-600 hover:text-amber-700 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DisclaimerPage;
